<div class="page-container">
    @if (notification) {
        <mat-card class="card-wrapper">
            <mat-card-header class="header-portal-notification">
                <mat-card-title>
                    <label class="icon">{{ notification.title }}</label>
                </mat-card-title>
            </mat-card-header>

            <mat-card-content class="content-portal-notification" [innerHTML]="notification.message | mxSafeHtml"/>

            <mat-card-actions class="actions-portal-notification">
                <mx-button [buttonModel]="acceptButton"></mx-button>
                <mx-button [buttonModel]="declineButton"></mx-button>
            </mat-card-actions>
        </mat-card>
    }
</div>

